// Generated by https://quicktype.io

export class PosMenu {
	venueKey: number;
	result: Result;
	shift4AccessToken: string;
	modifierSub: string;
	modifierExtra: string;
	modifierNo: string;
	prepModifier1: string;
	prepModifier2: string;
	prepModifier3: string;
	prepModifier4: string;
	prepModifier5: string;
	prepModifier6: string;
	prepModifier7: string;
	prepModifier8: string;
	prepModifier9: string;
	prepModifier10: string;
	course1: string;
	course2: string;
	course3: string;
	course4: string;
	course5: string;
	course6: string;
	course7: null;
	course8: null;
	course9: null;
	course10: null;
	onlineOrdering: OnlineOrdering;
	priceLevels: PriceLevel[];
	stations: Station[];
	timeRanges: TimeRange[];
	canvases: Canvase[];
	menuItems: PosMenuMenuItem[];

	public constructor(init?: Partial<PosMenu>) {
		Object.assign(this, init);
	}
}

export class Canvase {
	id: string;
	name: number | string;
	menuItems: CanvaseMenuItem[];
	prepModifier1?: string;
	prepModifier2?: string;
	prepModifier3?: string;

	public constructor(init?: Partial<Canvase>) {
		Object.assign(this, init);
	}
}

export class CanvaseMenuItem {
	id: string;
}

export class PosMenuMenuItem {
	id: string;
	name: string;
	menuId: string;
	gcName: string;
	price: number;
	price2: number;
	price3: number;
	price4: number;
	price5: number;
	price6: number;
	priceLevel: number | null;
	modUnit: number | null;
	kitchenComment: boolean | null;
	variablePrice: boolean | null;
	outOfStock: boolean | null;
	courseNumber: number | null;
	positionPrompt: boolean | null;
	effectiveTimeRange: number | null;
	priceTime1: number | null;
	priceTime2: number | null;
	priceTime3: number | null;
	priceTime4: number | null;
	priceTime5: number | null;
	priceTime6: null;
	priceDoublePercent: number | null;
	modCanvases: ModCanvase[];
	priceMod?: number;
	priceSub?: number;
	priceExtra?: number;
	priceNo?: number;
}

export class ModCanvase {
	id: string;
	canvasId: string;
	min: string;
	max: string;
	free?: string;
}

export class OnlineOrdering {
	employeeRecNum: number;
	creditPayment: null;
	giftPayment: null;
	commentsMenuId: number;
	exceptionMenuId: number;
	menus: number[];
}

export class PriceLevel {
	id: number;
	name: string;
	price_name1: number | string;
	price_name2: number | string;
	price_name3: number | null | string;
	price_name4: null | string;
	price_name5: null | string;
	price_name6: null | string;
}

export class Result {
	code: number;
	message: string;
}

export class Station {
	id: number;
	name: string;
}

export class TimeRange {
	id: number;
	name: string;
	day1Start1: string;
	day1End1: string;
	day1Start2: Day;
	day1End2: DayEnd2;
	day2Start1: string;
	day2End1: string;
	day2Start2: Day;
	day2End2: Day;
	day3Start1: string;
	day3End1: string;
	day3Start2: Day;
	day3End2: Day;
	day4Start1: string;
	day4End1: string;
	day4Start2: Day;
	day4End2: Day;
	day5Start1: string;
	day5End1: string;
	day5Start2: Day5Start2;
	day5End2: DayEnd2;
	day6Start1: string;
	day6End1: string;
	day6Start2: Day6Start2;
	day6End2: Day6End2;
	day7Start1: string;
	day7End1: string;
	day7Start2: Day;
	day7End2: Day;
}

export enum DayEnd2 {
	The1100Pm = "11:00pm",
	The1200Am = "12:00am",
}

export enum Day {
	The0500Pm = "05:00pm",
	The1200Am = "12:00am",
}

export enum Day5Start2 {
	The0400Pm = "04:00pm",
	The1200Am = "12:00am",
}

export enum Day6End2 {
	The0900Pm = "09:00pm",
	The1200Am = "12:00am",
}

export enum Day6Start2 {
	The0300Pm = "03:00pm",
	The1200Am = "12:00am",
}
